import currency from "currency.js";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { createRenderOptions } from "../richTextRenderer";
import { filterConfigs } from "./helpers";
import { CONFIGURATION_TYPE_IDS } from "../constants";
import { omitZeroCents } from "../../helpers/currency";
// import { getWeightLossSubscriptionMinPrice } from "@iscr/views/ordering/hooks/useWeightLossSubscriptionMinPrice";
// import { CTA_ON_CLICK_FUNCTION_IDS } from "@iscr/contentful/components/CTA";

export const replacePricesInString = (str, siteStatus) => {

	const prs_mc = siteStatus?.prs_mc || {};

	return str.replace(/{{prices\.(.*?)}}/g, (_, key) => {
		// if (key === "subcons_wl") {
		// 	const minCost = getWeightLossSubscriptionMinPrice(app.app_data.ws_data?.cat_data?.['pharm']);
		// 	return minCost && `$${minCost}`|| "";
		// }
		if (prs_mc[key] === undefined) {
			console.warn(`Price for ${key} not found in siteStatus`);
			return `{{prices.${key}}}`;
		}
		if (!prs_mc[key]) return `{{prices.${key}}}`;
		return currency(prs_mc[key]).format(omitZeroCents);
	})

};

export const formatRichText = (description, siteStatus, configurations = [], parsedFunctions = {}, isStatic = false) => {
	const richTextContent = description?.content;
	const richTextConfigurations = filterConfigs(configurations, CONFIGURATION_TYPE_IDS.RICH_TEXT);
	if (!richTextContent || !Array.isArray(richTextContent)) return null;
	const formattedRichTextContent = richTextContent.flatMap(item => {
		const { nodeType, content } = item;

		if (["paragraph", "heading-4", "heading-5"].includes(nodeType)) {
			return {
				...item,
				richTextConfigurations: richTextConfigurations[0] || {},
				content: content.map(contentItem => {
					if (contentItem.nodeType === "text") {
						return {
							...contentItem,
							value: replacePricesInString(contentItem.value, siteStatus),
						};
					}
					if (contentItem.nodeType === "embedded-entry-inline") {
						return {
							...contentItem,
							data: {
								...contentItem.data,
								target: {
									...contentItem.data.target,
									parsedFunctions: parsedFunctions
								},
							},
						};
					}
					return contentItem;
				}),
			};
		}
		if (nodeType === "embedded-entry-block") {
			return {
				...item,
				data: {
					...item.data,
					target: {
						...item.data.target,
						richTextConfigurations: richTextConfigurations[0] || {},
					},
				},
			};
		}

		return { ...item, richTextConfigurations: richTextConfigurations[0] || {} };
	});

	const updatedRichTextContent = {
		...description,
		content: formattedRichTextContent,
	};
	return documentToReactComponents(updatedRichTextContent, createRenderOptions(siteStatus, parsedFunctions, isStatic));
};
/*
	Returns all the rich text as a single string, with prices replaced.
*/
export const getFormattedRichText = (richText, siteStatus) =>
	richText?.content?.flatMap(({ content , nodeType}) => {
		if (nodeType === "paragraph") {
			return content.flatMap((contentItem) => {
				if (contentItem.nodeType === "text") {
					return replacePricesInString(contentItem.value, siteStatus);
				}
				return []
			});
		}
		return []
	})[0] || '';

export const replaceToken = (str, token, value="") => {
	const tk = token.replace(/[_ ]/g, '[_ ]');
	const reg = new RegExp(`\\{\\{\\s*${tk}\\s*\\}\\}`,'gi')
	return str.replace(reg, value);
}
